/* 置顶组件 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatUrl } from '@ifeng/public_method';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classnames } from '../../../utils/classnames';

class TopNewsComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };

    constructor(...argv) {
        super(...argv);

        const {
            content,
            componentOptions: { extendData, length },
        } = this.props;
        const formatData = this.formatData(content, extendData, length);

        this.state = {
            data: formatData,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.content !== nextProps.content) {
            const {
                content,
                componentOptions: { extendData, length },
            } = nextProps;

            this.setState({ data: this.formatData(content, extendData, length) });
        }
    }

    // 数据处理
    formatData(data = [], extendData = [], length = 3) {
        let dLen = length;

        // 先计算extendData内的数据
        const extendDataResult = [];

        for (const item of extendData) {
            dLen = length - item.componentOptions.length;

            for (const item2 of item.data) {
                extendDataResult.push(item2);
            }
        }

        // 主数据至少为1条
        if (dLen <= 0) dLen = 1;

        const mainData = [];

        for (let i = 0, j = dLen > data.length ? data.length : dLen; i < j; i++) {
            const item = data[i];

            mainData.push({
                id: item.id,
                thumbnail: item.thumbnail,
                url: item.notFormatUrl ? item.url : formatUrl(item.url),
                title: item.title,
                children: item.children,
            });
        }

        return mainData.concat(extendDataResult).slice(0, length);
    }

    // 渲染同行
    childrenView(children) {
        return children.map((item, index) => (
            <a className={styles.children} key={index} href={item.url} title={item.title} target="_blank" rel={relText}>
                {item.title}
            </a>
        ));
    }

    // 渲染单个的推荐位
    liView(recommend) {
        return recommend.map((item, index) => {
            if (item) {
                return (
                    <h3
                        key={index}
                        className={classnames(
                            index === 0 ? styles.first_title : styles.second_title,
                            'top_news_title',
                        )}>
                        <a href={item.url} title={item.title} target="_blank" rel={relText}>
                            {item.title}
                        </a>
                        {item.children && item.children.length > 0 && this.childrenView(item.children)}
                    </h3>
                );
            } else {
                return null;
            }
        });
    }

    // 渲染推荐位组
    topNewsView(data = [], groupLength = 1, itemLength = 3) {
        const element = [];

        for (let i = 0, j = data.length, k = 1; k <= groupLength; i += itemLength, k += 1) {
            let recommend = null;
            let isBreak = false;

            if (k === groupLength) {
                if (i < j) recommend = data.slice(i, j);
            } else if (i + itemLength > j) {
                recommend = data.slice(i, j);
                isBreak = true;
            } else {
                recommend = data.slice(i, i + itemLength);
            }

            if (recommend) {
                element.push(
                    <div key={k} className={styles.topNews}>
                        {this.liView(recommend)}
                    </div>,
                );
            }

            if (isBreak) break;
        }

        return element;
    }

    render() {
        if (!this.props || !this.props.content) return null; // 没有content返回null

        const { data } = this.state;
        const { componentOptions } = this.props;
        const groupLength =
            componentOptions && componentOptions.groupLength !== undefined ? componentOptions.groupLength : 1;
        const itemLength =
            componentOptions && componentOptions.itemLength !== undefined ? componentOptions.itemLength : 3;

        if (data.length <= 0) return null; // 没有数据且无法编辑返回null

        const element = this.topNewsView(data, groupLength, itemLength);

        return <div>{element}</div>;
    }
}

export default errorBoundary(TopNewsComponent);
